module.exports = __webpack_public_path__ + "img/736-7fb6b0.png";